import { TypographyH1 } from "@/components/typography/H1";
import { Button } from "@/components/ui/button";
import { Link } from "@tanstack/react-router";

const Page404 = () => {
  return (
    <div className="w-full h-screen flex flex-col items-center justify-center dark:bg-brand-gray-950">
      <TypographyH1>Page not found</TypographyH1>
      <div className="text-sm text-slate-600 dark:text-slate-300 font-light mt-4">
        Sorry, we could not find the page you are looking for.
      </div>

      <div className="text-sm text-slate-600 dark:text-slate-300 font-light mb-1 mt-24">
        Try one of these instead
      </div>
      <div className="flex gap-4">
        <Button variant="link">
          <Link to="/">Home</Link>
        </Button>
        <Button variant="link">
          <a href="https://www.numerous.com" target="_blank" rel="noreferrer">
            numerous.com
          </a>
        </Button>
        <Button variant="link">
          <a
            href="https://www.numerous.com/docs"
            target="_blank"
            rel="noreferrer"
          >
            Documentation
          </a>
        </Button>
      </div>
    </div>
  );
};

export default Page404;
